import ContainerIconValuesManager from "../../components/ContainerIconValuesManager";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropdownDateRange from "components/datetime/DropdownDateRange";
import { translations } from "../translations";
import useCustomTranslation from "core/customTranslation";
import { useNavigate, useLocation, Link } from "react-router-dom";

const Paramsitem = ({ item, handleResetZoom, dateRange, setDateRange }) => {
    const { t: _Tf } = useTranslation("forms");
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tr } = useTranslation("routes");
    const { t: _tC } = useCustomTranslation(translations);

    const navigate = useNavigate();
    const location = useLocation();

    const styleLabel = {
        maxWidth: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
    };
    const styleValue = {
        fontSize: "1.1rem",
        fontWeight: "400",
    };
    return (
        <>
            <div className="row">
                <div className="col-md col-12">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div className="row mb-2">
                                <div className="col small text-secondary" style={styleLabel}>
                                    {_Tf("container.address")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.address}, {item.number}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.city")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.codpost}-{item.municipality}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.province")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.province}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.country")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.country}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md col-12">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.model")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.model_name}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.manufacturer")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.manufactured}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md col-12" style={{ minWidth: "268px" }}>
                    <div className="col asset-icon-measures p-2">
                        <ContainerIconValuesManager item={item} />
                    </div>
                </div>
            </div>
            <div className="row ps-4 pe-4">
                <div className="col-12 text-center mb-2" style={{ borderBottom: "1px solid #e9e9e9" }}>
                    <strong>{_Tf("container.parameters")}</strong>
                </div>
                <div className="col text-center">
                    <div className="small">{_Tf("container.height")}</div>
                    <div>{item.height}</div>
                </div>
                <div className="col text-center">
                    <div className="small">{_Tf("container.volume")}</div>
                    <div>{item.volume}</div>
                </div>
                <div className="col text-center">
                    <div className="small">{_Tf("container.offset")}</div>
                    <div>{item.offset}</div>
                </div>
                <div className="col text-center">
                    <div className="small">{_Tf("container.cFactor")}</div>
                    <div>{item.c_factor}</div>
                </div>
                <div className="col text-center">
                    <div className="small">{_Tf("container.dFactor")}</div>
                    <div>{item.d_factor}</div>
                </div>
            </div>
            <div className="row">
                {item.has_device ? (
                    <div className="col-12 d-flex justify-content-end mt-5">
                        {location.pathname.includes("/unloads/") ? (
                            <Link className="btn btn-primary btn-sm me-3" to={`/data-view/data-container/${item.uid}/`}>
                                <FontAwesomeIcon icon="chart-column" className="me-2" />
                                {_Tt("common.graphs")}
                            </Link>
                        ) : (
                            <Link className="btn btn-primary btn-sm me-3" to={`/data-view/data-container/unloads/${item.uid}/`}>
                                <FontAwesomeIcon icon="truck-field" className="me-2" />
                                {_Tr("labels.unloads")}
                            </Link>
                        )}

                        {!location.pathname.includes("/unloads/") && (
                            <button className="btn btn-sm btn-outline-primary me-3" onClick={handleResetZoom}>
                                <FontAwesomeIcon icon="rotate-right" /> Zoom
                            </button>
                        )}

                        <div style={{ display: "inline-block", minWidth: "200px" }}>
                            <DropdownDateRange size="sm" dateRange={dateRange} setDateRange={setDateRange} maxDays={30} />
                        </div>
                    </div>
                ) : (
                    <div className="alert alert-secondary text-center mt-4">{_tC("no.devices")}</div>
                )}
            </div>
        </>
    );
};
export default Paramsitem;
